// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { CandidatesAPI } from 'api/endpoints';
// Interfaces and types
import {
  IGetCandidateRes,
  IGetCandidatesRes,
  ICreateCandidateBody,
  ICreateCandidateRes,
  IUpdateCandidateBodyWithParam,
} from 'types/candidateTypes';
import { IResMessage, TQueryParams, IErrorRes } from 'types/appTypes';

const getCandidatesListAsync = createAsyncThunk<
  IGetCandidatesRes,
  TQueryParams,
  { rejectValue: IErrorRes }
>('candidates/getCandidatesList', async (params: TQueryParams, { rejectWithValue }) => {
  try {
    return await CandidatesAPI.getCandidateList(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const createCandidateAsync = createAsyncThunk<
  ICreateCandidateRes,
  ICreateCandidateBody,
  { rejectValue: IErrorRes }
>('candidates/createCandidate', async (cred: ICreateCandidateBody, { rejectWithValue }) => {
  try {
    return await CandidatesAPI.createCandidate(cred);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const getCandidateDetailsAsync = createAsyncThunk<
  IGetCandidateRes,
  number,
  { rejectValue: IErrorRes }
>('candidates/getCandidateDetails', async (id: number, { rejectWithValue }) => {
  try {
    return await CandidatesAPI.getCandidate(id);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const updateCandidateAsync = createAsyncThunk<
  IResMessage,
  IUpdateCandidateBodyWithParam,
  { rejectValue: IErrorRes }
>(
  'candidates/updateCandidate',
  async (cred: IUpdateCandidateBodyWithParam, { rejectWithValue }) => {
    try {
      return await CandidatesAPI.updateCandidate(cred);
    } catch (error) {
      return rejectWithValue(error as IErrorRes);
    }
  },
);

const deleteCandidateAsync = createAsyncThunk<IResMessage, number, { rejectValue: IErrorRes }>(
  'candidates/deleteCandidate',
  async (id: number, { rejectWithValue }) => {
    try {
      return await CandidatesAPI.deleteCandidate(id);
    } catch (error) {
      return rejectWithValue(error as IErrorRes);
    }
  },
);

export {
  getCandidatesListAsync,
  createCandidateAsync,
  getCandidateDetailsAsync,
  updateCandidateAsync,
  deleteCandidateAsync,
};
